module.exports = __webpack_public_path__ + "9bfc4a7bcced7357fbb45fe809e4aaeb.pdf";